import React from "react";
import {
  ButtonDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Badge,
  Button,
} from "reactstrap";
import moment from "moment";
import { Container as DragContainer, Draggable } from "react-smooth-dnd";
import ScheduleVisit from "./ScheduleVisit";
import { Spinner } from "react-activity";
import "react-activity/dist/react-activity.css";
const ReservationScheduleDayLayout = ({
  schedule,
  schIndex,
  date,
  venuesLookup,
  addVisitToReservationSchedule,
  removeVisitToReservationSchedule,
  updateReservationProps,
  deleteReservationProps,
  applyDrag,
  isWithinTrip,
  createNewReservationSchedule,
  reservation_id,
  calWeekIndex,
  calDayIndex,
  isLoading,
  zoom,
  isOldDaysEnabled,
  savingReservationSchedule,
}) => {
  const venueOptions = venuesLookup && venuesLookup.data ? venuesLookup.data : [];
  return (
    <div className="reservation-schedule-day" style={{ fontSize: zoom }}>
      <span className="reservation-schedule-day__header">
        {moment(date, "YYYY-MM-DD HH:mm:ss").format("Do MMM YYYY")}
      </span>
      {schedule != null ? (
        <>
          <div className="reservation-schedule-day__status">
            {savingReservationSchedule ? (
              <Badge color="warning" style={{ color: "white" }}>
                <Spinner size={5} animating={true} color={"#fff"} /> Saving
              </Badge>
            ) : (
              <Badge color="success" style={{ color: "white" }}>
                Saved
              </Badge>
            )}
            {/* <Badge color="info" style={{ color: "white" }}>
              {"Score: " + schedule.schedule.score}
            </Badge> */}
          </div>
          <DragContainer
            groupName={"mainList"}
            getChildPayload={(i) => schedule.schedule.visits[i]}
            onDrop={(e) => {
              let newList = applyDrag(schedule.schedule.visits, e);

              updateReservationProps([
                {
                  prop: "reservationSchedule." + schIndex + ".schedule.visits",
                  value: newList,
                },
              ]);
            }}
            dropPlaceholder={{
              animationDuration: 150,
              showOnTop: true,
              className: "drop-preview",
            }}
            className="reservation-schedule-day__dropzone"
          >
            {schedule.schedule.visits.map((visit, index) => {
              if (
                moment(date, "YYYY-MM-DD HH:mm:ss").diff(
                  moment().format("YYYY-MM-DD")
                ) < 0 &&
                !isOldDaysEnabled
              ) {
                return (
                  <ScheduleVisit
                    key={index}
                    enabled={false}
                    visit={visit}
                    schIndex={schIndex}
                    vIndex={index}
                    updateReservationProps={updateReservationProps}
                    removeVisitToReservationSchedule={
                      removeVisitToReservationSchedule
                    }
                  />
                );
              } else {
                return (
                  <Draggable key={index}>
                    <ScheduleVisit
                      enabled={true}
                      visit={visit}
                      schIndex={schIndex}
                      vIndex={index}
                      updateReservationProps={updateReservationProps}
                      removeVisitToReservationSchedule={
                        removeVisitToReservationSchedule
                      }
                    />
                  </Draggable>
                );
              }
            })}
            {moment(date, "YYYY-MM-DD HH:mm:ss").diff(
              moment().format("YYYY-MM-DD")
            ) >= 0 || isOldDaysEnabled ? (
              <ButtonDropdown
                isOpen={schedule.schedule.isOpenDropdown}
                toggle={() => {
                  updateReservationProps([
                    {
                      prop:
                        "reservationSchedule." +
                        schIndex +
                        ".schedule.isOpenDropdown",
                      value: !schedule.schedule.isOpenDropdown,
                    },
                  ]);
                }}
                style={{ width: "100%", marginTop: 5 }}
                className="reservation-schedule-day__add"
              >
                <DropdownToggle
                  outline
                  color="success"
                  className="reservation-schedule-day__add-toggle"
                >
                  <i className={"fa fa-plus"} />
                </DropdownToggle>
                <DropdownMenu className="reservation-schedule-day__menu">
                  {venueOptions.map((item) => {
                    return (
                      <DropdownItem
                        key={item.id}
                        style={{ fontSize: zoom }}
                        onClick={() => {
                          addVisitToReservationSchedule(
                            schIndex,
                            JSON.parse(JSON.stringify(item))
                          );
                        }}
                      >
                        <span>{item.name}</span>
                        <Badge color="info" style={{ color: "white" }}>
                          {item.score}
                        </Badge>
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </ButtonDropdown>
            ) : null}
          </DragContainer>
        </>
      ) : isWithinTrip ? (
        <div className="reservation-schedule-day__empty">
          <Button
            className="reservation-schedule-day__empty-button"
            outline
            color={"faiz1"}
            onClick={() => {
              createNewReservationSchedule(
                moment(date, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD"),
                reservation_id,
                calWeekIndex,
                calDayIndex
              );
            }}
            disabled={isLoading}
          >
            {isLoading ? (
              <Spinner size={10} animating={true} color={"#c87244"} />
            ) : (
              <i className={"fa fa-plus"} color={"faiz1"} />
            )}
            <br />
            <span>Make a schedule</span>
          </Button>
        </div>
      ) : (
        <div />
      )}
    </div>
  );
};

export default ReservationScheduleDayLayout;
